/**
 * 胎号管理的新增页面 货品配置
 * @author zjs
 * @time 2017-09-18
 */
export default {
     data () {
        return {
            productConfig: [{
                prop: 'product',
                label: '货品编码',
                width: 110,
                json: {
                    size: 'small',
                    api: 'manage/product',
                    prop: 'product_cai'
                },
                component: 'LyAutoProduct'
            }, {
                prop: 'product',
                label: '货品名称',
                width: 286,
                json: {
                    size: 'small',
                    prop: 'product_name'
                },
                component: 'LyAutoProduct'
            }, {
                prop: 'taihao_no',
                label: '胎号/DOT号',
                width: 140,
                component: 'ElInput'
            }, {
                label: "销售时间",
                component: "LyDatePicker",
                prop: "xiaoshou_time",
                width: 140,
                json: {
                    type: 'date'
                },
                default: ""
            },{
                label: "客户编码",
                component: "LyAutoSearch",
                prop: "customer",
                width: 140,
                json: {
                    width: '661px',
                    api: 'api/customer',
                    prop: 'customer_account',
                    fields: [{
                        label: '客户编码',
                        prop: 'customer_account',
                        width: 90
                    }, {
                        label: '客户名称',
                        prop: 'customer_name',
                        width: 270
                    }, {
                        label: '联系人',
                        prop: 'customer_contact',
                        width: 160
                    }, {
                        label: '联系电话',
                        prop: 'customer_tel',
                        width: 140
                    }]
                },
                default: {}
            },{
                label: "销售客户",
                component: "LyAutoSearch",
                prop: "customer",
                width: 280,
                json: {
                    width: '661px',
                    api: 'api/customer',
                    prop: 'customer_name',
                    fields: [{
                        label: '客户编码',
                        prop: 'customer_account',
                        width: 90
                    }, {
                        label: '客户名称',
                        prop: 'customer_name',
                        width: 270
                    }, {
                        label: '联系人',
                        prop: 'customer_contact',
                        width: 160
                    }, {
                        label: '联系电话',
                        prop: 'customer_tel',
                        width: 140
                    }]
                },
                default: {}
            }]
        }
    }
}